import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/quizzes', parameters);
    }

    async updateQuestionsForQuiz(id, params = {}) {
        return this.submit('post', `/${id}/questions`, params);
    }

    async getAll(params = {}) {
        return this.submit('get', '/list/all', params);
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/api/Quiz.js